<template>
    <Tooltip :content="'Help'" placement="right" :transfer="true">
        <a href="mailto:support@akitaapp.com" target="_blank">
            <li
                class="
                    c-sidebar-menu__item
                    ivu-menu-item
                    c-sidebar-menu__item-never-active
                "
                :name="name"
                id="intercom-launcher"
            >
                <Icon :custom="icon" size="20" /></li
        ></a>
    </Tooltip>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            name: "Help",
            icon: "icon icon-headphones-customer-support-human",
            open: false,
        };
    },
    created() {},
};
</script>
